{
  "ariaLabel": "Pestañas de mapeo FAA",
  "tabs": {
    "aircraftMapping": "Mapeo de aeronaves",
    "tailManualAdd": "Agregar cola manual",
    "blacklist": "Bloqueados",
    "tailRequests": "Solicitudes de cola",
    "pendingApprovals": "Aprobaciones pendientes"
  },
  "tailMappingTab": {
    "title": "Añadir número de cola FAA manualmente",
    "description": "Añadir una nueva matrícula a la base de datos de la FAA y vincularla a un tipo de aeronave. La matrícula estará disponible inmediatamente para cargas masivas y programación.",
    "form": {
      "labels": {
        "tailNumber": "Matrícula",
        "manufacturer": "Fabricante",
        "model": "Modelo",
        "aircraft": "Tipo de aeronave"
      },
      "placeholders": {
        "tailNumber": "N12345",
        "manufacturer": "CESSNA",
        "model": "172S"
      },
      "buttons": {
        "add": "Añadir matrícula",
        "adding": "Añadiendo..."
      },
      "validation": {
        "tailNumberRequired": "El número de cola es obligatorio",
        "tailNumberFormat": "Matrícula debe contener solo letras, números y guiones",
        "tailNumberLength": "El número de cola debe tener entre 2 y 10 caracteres",
        "manufacturerRequired": "El fabricante es obligatorio",
        "manufacturerLength": "El fabricante debe tener entre 2 y 100 caracteres",
        "modelRequired": "El modelo es obligatorio",
        "modelLength": "El modelo debe tener entre 1 y 100 caracteres",
        "aircraftRequired": "Selecciona un tipo de aeronave"
      }
    },
    "recentlyAdded": {
      "title": "Matrículas añadidas recientemente",
      "emptyState": "No hay matrículas añadidas recientemente",
      "columns": {
        "tailNumber": "Matrícula",
        "manufacturer": "Fabricante",
        "model": "Modelo",
        "source": "Origen",
        "added": "Añadido",
        "actions": "Acciones"
      },
      "sources": {
        "faaImport": "Importar FAA",
        "justNow": "Ahora"
      }
    },
    "deleteDialog": {
      "title": "Eliminar Matrícula",
      "confirmationText": "¿Está seguro de que desea eliminar la matrícula <strong>{{tailNumber}}</strong>? Esta acción no se puede deshacer.",
      "instructionsText": "Para confirmar la eliminación, escribe <strong>\"delete\"</strong> en el campo a continuación:",
      "placeholder": "Escribe 'eliminar' para confirmar",
      "validationError": "Escribe 'delete' exactamente",
      "buttons": {
        "cancel": "Cancelar",
        "delete": "Eliminar",
        "deleting": "Eliminando..."
      }
    },
    "tooltips": {
      "delete": "Eliminar matrícula {{tailNumber}}"
    },
    "messages": {
      "alreadyExists": "El número de cola {{tailNumber}} ya existe en la base de datos",
      "permissionDenied": "No tienes permiso para añadir matrículas",
      "addFailed": "No se pudo añadir la matrícula: {{message}}",
      "addSuccess": "Número de cola {{tailNumber}} añadido correctamente",
      "addSuccessNoMapping": "Matrícula {{tailNumber}} añadida, pero el mapeo puede requerir revisión manual",
      "deleteFailed": "No se pudo eliminar la matrícula: {{message}}",
      "deleteSuccess": "Matrícula {{tailNumber}} eliminada correctamente",
      "error": "Error: {{message}}",
      "unexpectedError": "Ocurrió un error inesperado",
      "unexpectedDeleteError": "Ocurrió un error inesperado al eliminar"
    }
  },
  "suggestedAircraftCell": {
    "confidence": {
      "high": "Alto",
      "medium": "Medio",
      "label": "confianza"
    },
    "score": "Puntaje:",
    "tooltip": {
      "matchDetails": "Detalles",
      "faaInput": "Entrada FAA (lo que estás mapeando):",
      "suggestedAircraft": "Aeronave sugerida:",
      "modelComparison": "Comparación de modelos:",
      "faa": "FAA:",
      "airplx": "AirPlx:",
      "legend": {
        "match": "✓ igual",
        "case": "~ caso",
        "different": "✗ diferente"
      },
      "whyMatch": "¿Por qué coincide?",
      "matchQuality": "Detalles de coincidencia:",
      "verifiedMatch": "✓ Coincidencia exacta verificada",
      "manufacturer": "Fabricante:",
      "model": "Modelo:",
      "noDirectMatch": "sin coincidencia",
      "scoreLabel": "puntaje",
      "matchLabels": {
        "highMatch": "coincide ✓",
        "mediumMatch": "coincide ~",
        "noMatch": "no coincide ✗"
      },
      "otherMatches": "Otras coincidencias posibles:",
      "clickAlternative": "Haz clic en una alternativa para seleccionarla",
      "instructions": "Clic en ✓ para aprobar o selecciona manualmente si es incorrecto"
    },
    "matchReasons": {
      "csvVerified": "Esta cadena FAA \"{{matchedString}}\" fue previamente asociada a esta aeronave",
      "csvVerifiedFallback": "Encontrado en mapeos de base de datos verificados",
      "historical": "Similar a uno mapeado anteriormente: \"{{matchedString}}\"",
      "historicalFallback": "Basado en patrones históricos de mapeo",
      "combined": "Coincidencia encontrada usando historial de base de datos y coincidencia de texto aproximada",
      "traditional": "Coincidencia encontrada mediante búsqueda aproximada de fabricante y modelo",
      "unknown": "Método desconocido"
    }
  }
}
